import React, { useState } from 'react';
import InputWithValidation from './../../Basic/InputWithValidation';
import NicknameInputWithValidation from './../../Basic/NicknameInputWithValidation';
import { emailValidation, passwordValidation, usernameValidation } from './../../Basic/validationFuncs';
import getQueryStringParams from './../../Helpers/QueryString';
import { cookie } from './../../Helpers/EventLogger';
import { setCookie, getCookie } from './../../Helpers/cookies';
import content from './../../Translations/Registration';
import styles from './../../../../../Css/Components/registrationForm.css';
import CONSTS from './../../Consts/Consts';
import { langsAllowed } from './../../Lang/lng';

function RegistrationForm(props) {
    const queryString = getQueryStringParams(location.search);
    const configDef = {
        domain: queryString['wl'] || 'imlive.com',
        wid: queryString['wid'] || "",
        linkid: queryString['linkid'] || 701,
        ptype: queryString['ptype'] || 1,
        promocode: queryString['promocode'] || "",
        ref_1: queryString['ref_1'] || "",
        ref_2: queryString['ref_2'] || "",
        ref_3: queryString['ref_3'] || "",
        ref_4: queryString['ref_4'] || "",
        ref_5: queryString['ref_5'] || "",
        lang: langsAllowed.indexOf(queryString['c']) > -1 ? queryString['c'] : ""
    };
    const config = Object.assign(configDef, props.config);

    const lang = config.lang || 'en-EN';
    let text = content[lang] ? content[lang] : content['en-EN'];

    if (config.text) {
        Object.assign(text, config.text);
    }
    window.setCookie = setCookie;
    window.getCookie = getCookie;
    const [username, setUsername] = useState({ val: "", valid: false });
    const [password, setPassword] = useState({ val: "", valid: false });
    const [email, setEmail] = useState({ val: "", valid: false, errorText: "" });
    const [registered, setRegistered] = useState(false);
    const [formDisabled, setDisabled] = useState(false);
    const [formData, setFormData] = useState({});
    const [signupResponse, setSignupResponse] = useState({});

    const target = config.onSuccess.newTab ? "_blank" : "";

    const consts = {
        onSuccessAction: {
            successMessage: "successMessage"
        }
    };

    function formIsValid() {
        return username.valid && email.valid && password.valid && !formDisabled;
    }

    if (registered) {
        onRegistered(config.wid);
    }

    function submitForm(event) {
        event.preventDefault();
        if (!formIsValid()) {
            return;
        }
        setDisabled(true);

        const { ptypeToLinkID } = CONSTS;

        let linkid;

        if (queryString['linkid']) {
            linkid = queryString['linkid'];
        } else if (config.domain == "imlive.com") {
            linkid = config.linkid || 701;
            if (config.lang && config.lang != 'en-EN') {
                if (config.ptype == 22) {
                    linkid = 1319;
                }
            }
        } else {
            linkid = ptypeToLinkID[config.ptype] || -1;
        }

        const data = {
            domain: config.domain,
            username: username.val,
            password: password.val,
            email: email.val,
            useragent: navigator.userAgent,
            //long aff id is expected
            affiliateid: config.wid || 123450,
            linkid: linkid,
            promocode: config.promocode,
            impid: cookie("cookie_impid"),
            perimpid: cookie("cookie_perimpid"),
            addclick: 1,
            referrer: document.referrer,
            ref_1: config.ref_1,
            ref_2: config.ref_2,
            ref_3: config.ref_3,
            ref_4: config.ref_4,
            ref_5: config.ref_5,
            ...(config.autologin && { autologin: config.autologin }),
        };


        config.preSubmit && config.preSubmit(data);
        setFormData(data);

        register(data);
        if (config.onRegStart && typeof config.onRegStart === "function") {
            config.onRegStart();
        }
    }

    function register(data) {
        const url = config.signupAPI ?? '/api/signup';

        fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(res => res.json())
            .then(
                (result) => {
                    setDisabled(false);
                    result = typeof result === "string" ? JSON.parse(result) : result;
                    setSignupResponse(result);
                    if (result.Code === 200) {
                        let url;

                        const gotopage = config.gotopage ? config.gotopage : encodeURIComponent(getQueryStringParams(location.href)["gotopage"]);
                        const action = config.action ? `&action=${config.action}` : ""
                        if (config.lang && config.lang != 'en-EN') {
                            const goto = gotopage.length > 0 && gotopage != "undefined" ? encodeURIComponent(`&cid=130&goto=`) + gotopage : "";
                            const destination = encodeURIComponent(`/services/directlinkhandler.ashx?c=${config.lang}${action}`) + goto;
                            const { code } = getQueryStringParams(result.LoginUrl);
                            const domain = (config.domain == 'imlive.com') ? 'lang.imlive.com' : config.domain;
                            url = `https://${domain}/services/entrypoint.ashx?code=${code}&destination=${destination}`;
                        } else {
                            url = gotopage.length > 0 && gotopage != "undefined" ? `${result.LoginUrl}&goto=${gotopage}` : result.LoginUrl;
                            url += action
                        }

                        setRegistered(url);
                        config.onSignupStatusUpdate?.({ status: 'registered', msg: encodeURIComponent(url) })

                    } else {
                        if (result.Code === 500) {
                            setEmail({
                                val: email.val,
                                valid: false,
                                errorText: "Your email seems to be invalid"
                            });
                            config.onSignupStatusUpdate?.({ status: 'error_status_500_invalid_email', msg: JSON.stringify(result) })

                        } else {
                            console.log('registration failed', result);
                            setEmail({
                                val: email.val,
                                valid: false,
                                errorText: "Server error, please try again later"
                            });
                            config.onSignupStatusUpdate?.({ status: 'error_failed', msg: JSON.stringify(result) })

                        }
                    }
                },
                (error) => {
                    setDisabled(false);
                    console.log(error);
                    config.onSignupStatusUpdate?.({ status: 'error_general', msg: error.toString() })
                }
            );
    }

    function onFieldFocus(field) {
        config.onSignupStatusUpdate?.({ status: `form_input_focus`, msg: `focus on field ${field} ` })
    }

    function onRegistered(wid) {

        setCookie('registered', '1', 1500);

        if (typeof firePixel == 'function') {
            firePixel();
        }

        if (typeof config.onSuccess === "function") {
            config.onSuccess(registered, formData, signupResponse);
            return;
        }
        if (config.onSuccess.actionType !== consts.onSuccessAction.successMessage) {
            if (target) {
                window.open(
                    config.onSuccess.redirectLink,
                    target
                );
            } else {
                location.href = config.onSuccess.redirectLink;
            }
        }
    }
    return (
        <div className="registration-component-wrapper">
            {!registered && (
                <form className="reg-form" >

                    <NicknameInputWithValidation
                        placeholder={text.nickNamePLCHLDR}
                        validation={(username) => usernameValidation(lang, username, config.usernameValidationAPI)}
                        initValidState="false"
                        onChange={setUsername}
                        value={username}
                        lang={lang}
                        onFocus={() => onFieldFocus("username")}
                        onClickSuggestion={() => config.onSignupStatusUpdate?.({ status: `click_form_suggestion` })}
                    />
                    <InputWithValidation
                        placeholder={text.passwordPLCHLDR}
                        validation={passwordValidation.bind(this, lang)}
                        initValidState="false"
                        onChange={setPassword}
                        value={password}
                        type="password"
                        onFocus={() => onFieldFocus("password")}
                    />
                    <InputWithValidation
                        placeholder={text.emailPCHLDR}
                        validation={emailValidation.bind(this, lang)}
                        errorText={email.errorText}
                        initValidState="false"
                        onChange={setEmail}
                        value={email}
                        onFocus={() => onFieldFocus("email")}
                    />
                    <input
                        type="submit" onClick={submitForm} value={config.cta || text.submit}
                        className={"form-submit " + (!username.valid || !email.valid || !password.valid || formDisabled ? "disabled" : "")}
                    />
                </form >
            )}
            {registered && config.onSuccess.actionType === consts.onSuccessAction.successMessage &&
                <div className="success-message">
                    <h1>
                        Thank you for registering at {config.domain}<br />
                        To procceed to website please click below
                    </h1>
                    <a href={config.onSuccess.redirectLink} target={target}>
                        Click here
                    </a>
                </div>
            }
        </div>
    );
}

export default RegistrationForm;